import getUrlVars from './getUrlVars'

function log (file, element, type = "log", always=true){
	//console.log(typeof getUrlVars().debug == "undefined" && !always)

	if(typeof getUrlVars().debug == "undefined" && !always){
		return;
	}

	file = file.split("/")
	if(typeof element == "string"){
		console[type]('['+file[file.length-1]+']',element);
	}
	else{
		console[type]('['+file[file.length-1]+']',Object.keys(element)[0], element[Object.keys(element)[0]])
	}
};

export default log;